import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_BACKEND_URL + "/api";

export default function TenantPortal() {
  const { slug } = useParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!slug) { setStatus("invalid"); return; }
    fetch(`${API_BASE}/tenant/config?subdomain=${encodeURIComponent(slug)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.tenant) {
          sessionStorage.setItem("tenant_slug", slug);
          setStatus("valid");
        } else {
          setStatus("invalid");
        }
      })
      .catch(() => setStatus("invalid"));
  }, [slug]);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground text-sm">Loading portal...</div>
      </div>
    );
  }

  if (status === "valid") {
    // Redirect to tenant-prefixed login URL to maintain branding in URL
    return <Navigate to={`/${slug}/login`} replace />;
  }

  // Invalid slug — go to default login
  return <Navigate to="/login" replace />;
}
